import React from 'react';
import { Box, Button } from '@mui/material';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { AddCircleOutline } from '@mui/icons-material';
import { PageContainer } from 'components/shared/Page/PageContainer';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';

import { InventoryTable } from './InventoryTable';

export const ListInventoryPage = () => {
  const history = useHistory();
  const account = useSelector<any, any>(state => state.account);

  return (
    <PageContainer title="Inventory">
      <CardContainer
        title="List"
        actionBtn={
          <Button variant="contained" startIcon={<AddCircleOutline />} onClick={() => history.push('/equipment/new')}>
            Add Equipment
          </Button>
        }
      >
        <Box sx={{ height: 'calc(100% - 3rem)' }}>
          <InventoryTable accountId={account.id} />
        </Box>
      </CardContainer>
    </PageContainer>
  );
};
